import React, { useState } from "react";
import ChoVayApi from "service/choVayApi";
import { pushNotification } from "../../../../utils/notifications";

export const BtnXuatExcel = ({ params }) => {
    const [isLoading, setIsLoading] = useState(false);
    const handleExport = async () => {
        if (isLoading) return;
        setIsLoading(true);
        try {
            const response = await ChoVayApi.xuatBaoCaoDanhSachNo(params);
            if (response.status === 200) {
                const contentDisposition = response.headers["content-disposition"];
                let fileName = "BaoCaoDanhSachNo.xlsx";

                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="?(.+)"?/);
                    if (match && match[1]) {
                        fileName = match[1];
                    }
                }
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                pushNotification("Xuất Excel thành công!", "success", "TOP_CENTER", 2000);
            } else {
                pushNotification("Xuất Excel thất bại!", "error", "TOP_CENTER", 2000);
            }
        } catch (error) {
            console.error("Lỗi khi xuất Excel:", error);
            pushNotification("Có lỗi xảy ra khi xuất Excel!", "error", "TOP_CENTER", 2000);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <a 
            type="button" 
            className="con-bgnew color-print1" 
            onClick={handleExport}
            style={{ 
                cursor: isLoading ? 'not-allowed' : 'pointer', 
                opacity: isLoading ? 0.5 : 1 
            }}
        >
            {isLoading ? (
                <span>Đang xuất...</span>
            ) : (
                <img src="/app-assets/images/icon-tai-xuong-v2.png" title="Xuất Excel" />
            )}
        </a>
        
    );
};

